module.exports = __webpack_public_path__ + "img/angles-down.bb7c333c.svg";